import { useEffect, useRef } from "react"
import { useLocation, useSearchParams } from "react-router-dom"

export const useQuickActionPopup = (quickAction: string, openPopup: () => void, enabled = true) => {
  const location = useLocation()

  const [searchParams] = useSearchParams()

  const lastOpenKeyRef = useRef("")

  useEffect(() => {
    if (searchParams.get("quickAction") !== quickAction) {
      lastOpenKeyRef.current = ""
      return
    }

    if (!enabled) {
      return
    }

    const openKey = `${location.key}:${location.pathname}:${location.search}:${quickAction}`

    if (lastOpenKeyRef.current === openKey) {
      return
    }

    lastOpenKeyRef.current = openKey

    openPopup()
  }, [enabled, location.key, location.pathname, location.search, openPopup, quickAction, searchParams])
}
